module.exports = __webpack_public_path__ + "img/a5.74aabb1b.jpg";